module.exports = __webpack_public_path__ + "media/images/icons/brands/doc-d1f00b38e668b7eb0960347081e20ba0.svg";